import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Besprechung} from '../../../generated-api';

@Injectable({
  providedIn: 'root'
})
export class BesprechungStoreService {

  private readonly _besprechung = new BehaviorSubject<Besprechung>(null);
  readonly besprechung$ = this._besprechung.asObservable();

  get besprechung(): Besprechung {
    return this._besprechung.getValue();
  }

  set besprechung(val: Besprechung) {
    this._besprechung.next(val);
  }

  private readonly _loading = new BehaviorSubject<boolean>(false);
  readonly loading$ = this._loading.asObservable();

  get loading(): boolean {
    return this._loading.getValue();
  }

  set loading(val: boolean) {
    this._loading.next(val);
  }

  private readonly _searchError = new BehaviorSubject<string>(null);
  readonly searchError$ = this._searchError.asObservable();

  get searchError(): string {
    return this._searchError.getValue();
  }

  set searchError(val: string) {
    this._searchError.next(val);
  }

  constructor() {
  }
}
